import validate from "/usr/src/app/content/n3-spas-ef2cdc0d-214c-41d9-8983-9616fe1d815d/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-spas-ef2cdc0d-214c-41d9-8983-9616fe1d815d/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}